<div class="container">
    <app-spinner [state]="loading"></app-spinner>
    <app-toastr [properties]="alertProperties" *ngIf="showAlert"></app-toastr>
    <div class="form-wrapper">
        <header>
            <img src="assets/images/temporary-logo.png" alt="System Logo" class="logo" />
        </header>
        <h2 class="form-title">Vehicle and Owner Details</h2>
        <form class="vehicle-form">
            <label for="vehicle-registration">What’s your Vehicle Registration Number?</label>
            <app-text-field appNoSpace [control]="$any(createForm.get('plateNumber'))" [submitted]="submitted"
                [placeholder]="'XXXXXX'" [errorMessage]="'Plate Number is required'">
            </app-text-field>
            <div class="form-group">
                <label for="nric">Vehicle Owner’s NRIC</label>
                <small class="info-text">Your IC Number is required to retrieve your NCD (No-Claim Discount)</small>
                <app-text-field appNoSpace [type]="'number'" [control]="$any(createForm.get('nric'))" [submitted]="submitted"
                    [placeholder]="'XXXXXXXXXXXXX'" [errorMessage]="'Customer NRIC is required'">
                </app-text-field>
            </div>
            <label for="owner-name">Owner’s Name</label>
            <app-text-field [control]="$any(createForm.get('name'))" [submitted]="submitted" 
                [placeholder]="'Siti Binti Mohd'" [errorMessage]="'Customer First Name is required'">
            </app-text-field>
            <div class="form-group">
                <label for="postcode">Postcode for Cover Note</label>
                <small class="info-text">Note: Your quotation price is based on your postcode</small>
                <app-text-field appNoSpace [control]="$any(createForm.get('postcode'))" [submitted]="submitted" [type]="'number'"
                    [placeholder]="'46300'" [errorMessage]="'Postcode is required'"></app-text-field>
            </div>
            <label for="owner-name">Vehicle Type</label>
            <app-multi-dropdown [control]="$any(createForm.get('vehicleType'))" [submitted]="submitted"
                [placeholder]="'Select Vehicle Type'" [errorMessage]="'Vehicle Type is required'"
                [items]="[{id: 'Car', name: 'Car'}]"
                [labelProperty]="'name'" [valueProperty]="'id'" [multiple]="false" [image]="false"
                [clearable]="false" [searchable]="false" [max]="1" (change)="onVehicleTypeChange($event)">
            </app-multi-dropdown>
            <ng-container *ngIf="createForm.get('vehicleType')!.value === 'Car'">
                <label for="owner-name">Car Type</label>
                <app-multi-dropdown [control]="$any(createForm.get('carType'))" [submitted]="submitted"
                    [placeholder]="'Select Car Type'" [errorMessage]="'Car Type is required'"
                    [items]="[{id: 'saloon', name: 'saloon'}, {id: 'non-saloon', name: 'non-saloon'}, {id: 'mpv', name: 'mpv'}, {id: 'suv', name: 'suv'}]"
                    [labelProperty]="'name'" [valueProperty]="'id'" [multiple]="false" [image]="false"
                    [clearable]="false" [searchable]="false" [max]="1">
                </app-multi-dropdown>
            </ng-container>
            <ng-container *ngIf="createForm.get('vehicleType')!.value === 'Car'">
                <label for="owner-name">Fuel Type</label>
                <app-multi-dropdown [control]="$any(createForm.get('fuelType'))" [submitted]="submitted"
                    [placeholder]="'Select Fuel Type'" [errorMessage]="'Fuel Type is required'"
                    [items]="[{id: 'petrol', name: 'petrol'}, {id: 'diesel', name: 'diesel'}, {id: 'hybrid', name: 'hybrid'}, {id: 'electric', name: 'electric'}]"
                    [labelProperty]="'name'" [valueProperty]="'id'" [multiple]="false" [image]="false"
                    [clearable]="false" [searchable]="false" [max]="1">
                </app-multi-dropdown>
            </ng-container>
            <ng-container *ngIf="createForm.get('vehicleType')!.value === 'Car'">
                <label for="owner-name">Ownership Type</label>
                <app-multi-dropdown [control]="$any(createForm.get('ownershipType'))" [submitted]="submitted"
                    [placeholder]="'Select Ownership Type'" [errorMessage]="'Ownership Type is required'"
                    [items]="[{id: 'private', name: 'private'}, {id: 'company', name: 'company'}]"
                    [labelProperty]="'name'" [valueProperty]="'id'" [multiple]="false" [image]="false"
                    [clearable]="false" [searchable]="false" [max]="1">
                </app-multi-dropdown>
            </ng-container>
            <div class="ehailing-section" *ngIf="createForm.get('vehicleType')?.value === 'Car'">
                <h3 class="ehailing-title">E-Hailing</h3>
                <p class="ehailing-description">Is your vehicle used for e-hailing services?</p>
                <div class="ehailing-buttons">
                    <button class="button yes-button" [class.selected]="isYesSelected" (click)="selectYes()">Yes</button>
                    <button class="button no-button" [class.selected]="!isYesSelected" (click)="selectNo()">No</button>
                </div>
            </div>
            <label for="email">Email</label>
            <app-text-field [control]="$any(createForm.get('email'))" [submitted]="submitted" 
                [placeholder]="'siti@roadtax.com.my'" [errorMessage]="'Customer Email is required'"></app-text-field>
            <div class="form-group">
                <label for="whatsapp-number">Whatsapp Number</label>
                <small class="info-text">Please provide WhatsApp phone number to receive quote</small>
                <app-text-field [control]="$any(createForm.get('phoneNumber'))" appOnlyNumber [type]="'text'" inputmode="numeric" pattern="[0-9]*" [submitted]="submitted" 
                    [placeholder]="'0123456789'" [errorMessage]="'Customer Phone Number is required'">
                </app-text-field>
            </div>
            <button type="submit" class="submit-btn" style="margin-top: 20px;" (click)="onSave()">Submit</button>
        </form>
    </div>
</div>
<app-modal [template]="modalTemplate" [state]="modalState" [size]="modalSize"></app-modal>
<ng-template #saveTemplateHeader>
    <h4>Submit Quotation Request</h4>
</ng-template>
<ng-template #saveTemplateBody><p>Are you sure you want to submit the details and request a quotation?</p></ng-template>
<ng-template #saveTemplateFooter>
    <app-button [properties]="{name:'Cancel', type:'secondary'}" (click)="onCloseModal()"></app-button>
    <app-button [properties]="{name:'Submit', type:'success'}" (click)="onSubmit()"></app-button>
</ng-template>